<template>
    <mdb-container>
        <Vedheader></Vedheader>
        <Adminheader></Adminheader>
        <section class="mt-3">
            <mdb-row>
                <mdb-col md="8">
                    <h2>Catégories</h2>
                </mdb-col>
                <mdb-col md="4" class="text-right">
                    <mdb-btn color="primary" size="sm" v-on:click="addcategory()">Ajouter une catégorie</mdb-btn>
                </mdb-col>
            </mdb-row>
            <mdb-row>
                <!--Grid column-->
                <mdb-col xl="12" md="12">
                    <mdb-card class="card-body" style="margin-top: 1rem;" v-if="isLoading">
                        <div class="d-flex justify-content-center">
                            <mdb-spinner big color="blue" />
                        </div>
                    </mdb-card>
                    <mdb-container v-for="module in categories" :key="module.id">
                        <h4>{{module.name}}</h4>
                        <mdb-tbl striped>
                            <mdb-tbl-body>
                                <tr v-if="module.cats.length ===0">
                                    <td>AUCUNE CATÉGORIE</td>
                                </tr>
                                <tr v-for="(category, index) in module.cats" :key="category.id">
                                    <td>{{category.name}}</td>
                                    <td class="text-right">
                                        <mdb-btn color="info" size="sm" v-on:click="orderupcat(category.id)" v-if="index > 0"><mdb-icon icon="arrow-up"/></mdb-btn>
                                        <mdb-btn color="info" size="sm" v-on:click="orderdowncat(category.id)" v-if="index != Object.keys(module.cats).length - 1"><mdb-icon icon="arrow-down"/></mdb-btn>
                                        <mdb-btn color="primary" size="sm" v-on:click="editcat(category.id)"><mdb-icon icon="edit"/></mdb-btn>
                                        <mdb-btn color="danger" size="sm" v-on:click="deletecat(category.id)"><mdb-icon icon="trash-alt"/></mdb-btn>
                                    </td>
                                </tr>
                            </mdb-tbl-body>
                        </mdb-tbl>
                        <hr />
                    </mdb-container>
                </mdb-col>
            </mdb-row>
        </section>
        <mdb-footer color="mdb-color" class="font-small lighten-3 pt-4 mt-4 mt-5">
            <div class="footer-copyright text-center py-3">
                <mdb-container fluid>
                    &copy; 2020 Copyright: <a href="https://expertenvoyages.com/"> Expert En Voyage </a>
                </mdb-container>
            </div>
        </mdb-footer>

        <mdb-modal :show="confirmdelete" @close="confirm = false" size="sm" class="text-center" danger>
            <mdb-modal-header center :close="false">
                <p class="heading">Êtes-vous certain?</p>
            </mdb-modal-header>
            <mdb-modal-body>
                <mdb-icon icon="times" size="4x" class="animated rotateIn"/>
            </mdb-modal-body>
            <mdb-modal-footer center>
                <mdb-btn outline="danger" v-on:click="deletecat(cattodelete, true)">Oui</mdb-btn>
                <mdb-btn color="danger" @click="confirmdelete = false">Non</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>

        <mdb-modal :show="showaddeditform" @close="showaddeditform = false">
            <mdb-modal-header class="text-center">
                <mdb-modal-title tag="h4" bold class="w-100">{{addeditmode}} une catégorie</mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body class="mx-3 grey-text">
                <mdb-alert color="danger" v-if="currentcategory.error">
                    {{currentcategory.error}}
                </mdb-alert>
                <mdb-input label="Nom" class="mb-5" v-model="currentcategory.name"/>
                <mdb-select
                        v-model="currentcategory.modules"
                        placeholder="Choisir un module"
                        label="Module"
                />
                <mdb-input type="textarea" v-model="currentcategory.description" label="Description" :rows="5" />
            </mdb-modal-body>
            <mdb-modal-footer center>
                <mdb-btn v-on:click="savecategory()" color="indigo">Sauvegarder</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>
    </mdb-container>
</template>

<script>
    import Vedheader from '@/components/Header.vue';
    import Adminheader from '@/components/Adminheader.vue';
    import {
        mdbContainer,
        mdbFooter,
        mdbCol,
        mdbRow,
        mdbTbl,
        mdbTblBody,
        mdbBtn,
        mdbIcon,
        mdbModal,
        mdbModalHeader,
        mdbModalBody,
        mdbModalFooter,
        mdbSpinner,
        mdbInput,
        mdbSelect,
        mdbCard,
        mdbModalTitle,
        mdbAlert,
    } from 'mdbvue';
    import Apicall from '../libs/Apicall';

    export default {
        name: 'Preregistration',
        components: {
            Vedheader,
            mdbContainer,
            mdbFooter,
            mdbCol,
            mdbRow,
            Adminheader,
            mdbTbl,
            mdbTblBody,
            mdbBtn,
            mdbIcon,
            mdbModal,
            mdbModalHeader,
            mdbModalBody,
            mdbModalFooter,
            mdbSpinner,
            mdbInput,
            mdbSelect,
            mdbCard,
            mdbModalTitle,
            mdbAlert,
        },
        data() {
            return {
                categories: [],
                isLoading: true,
                selectedcategory: null,
                confirmdelete: null,
                cattodelete: 0,
                showaddeditform: false,
                addeditmode: 'Ajouter',
                currentcategory: {
                    id: 0,
                    name: '',
                    description: '',
                    modules: [],
                    error: null,
                },
            };
        },
        mounted() {
            this.getAndDisplayCategories();
        },
        methods: {
            resetAddEditModules() {
                this.currentcategory.modules = [];
                for (let i = 0; i <= Object.keys(this.categories).length; i += 1) {
                    if (Object.prototype.hasOwnProperty.call(Object.values(this.categories), i)) {
                        this.currentcategory.modules.push({
                            text: this.categories[i].name,
                            value: this.categories[i].id,
                        });
                    }
                }
            },
            getAndDisplayCategories() {
                const api = new Apicall();
                const self = this;
                api.getAdminCategories().then((response) => {
                    if (response.status === 'OK') {
                        self.categories = response.data;
                        self.isLoading = false;
                        self.resetAddEditModules();
                    }
                });
            },

            orderupcat(catid) {
                this.isLoading = true;
                const api = new Apicall();
                const self = this;
                this.categories = [];
                api.reordercat(catid, 'up').then((response) => {
                    if (response.status === 'OK') {
                        self.getAndDisplayCategories();
                    }
                });
            },

            orderdowncat(catid) {
                this.isLoading = true;
                const api = new Apicall();
                const self = this;
                this.categories = [];
                api.reordercat(catid, 'down').then((response) => {
                    if (response.status === 'OK') {
                        self.getAndDisplayCategories();
                    }
                });
            },

            editcat(catid) {
                this.addeditmode = 'Modifier';
                this.resetAddEditModules();
                this.showaddeditform = true;
                const api = new Apicall();
                const self = this;
                api.getCategoryDetails(catid).then((response) => {
                    if (response.status === 'OK') {
                        self.currentcategory.name = response.data.name;
                        self.currentcategory.description = response.data.description;
                        self.currentcategory.id = catid;
                        for (let i = 0; i <= Object.keys(self.currentcategory.modules).length; i += 1) {
                            if (Object.prototype.hasOwnProperty.call(Object.values(self.currentcategory.modules), i)) {
                                if (self.currentcategory.modules[i].value === response.data.module_id) {
                                    self.$set(self.currentcategory.modules[i], 'selected', true);
                                } else {
                                    self.$set(self.currentcategory.modules[i], 'selected', false);
                                }
                            }
                        }
                    } else {
                        self.showaddeditform = false;
                    }
                });
            },

            deletecat(catid, confirm = false) {
                if (!confirm) {
                    this.confirmdelete = true;
                    this.cattodelete = catid;
                } else {
                    this.confirmdelete = false;
                    this.isLoading = true;
                    const api = new Apicall();
                    const self = this;
                    this.categories = [];
                    api.deletecategory(catid).then((response) => {
                        if (response.status === 'OK') {
                            self.getAndDisplayCategories();
                        }
                    });
                }
            },

            addcategory() {
                this.addeditmode = 'Ajouter';
                this.currentcategory = {
                    id: 0,
                    name: '',
                    module: 0,
                    description: '',
                    modules: [],
                    error: null,
                };
                this.resetAddEditModules();
                this.showaddeditform = true;
            },

            savecategory() {
                const api = new Apicall();
                const self = this;
                api.saveCategory(this.currentcategory).then((response) => {
                    if (response.status === 'OK') {
                        self.showaddeditform = false;
                        self.isLoading = true;
                        self.categories = [];
                        self.getAndDisplayCategories();
                    } else {
                        self.currentcategory.error = response.msg;
                    }
                });
            },
        },
    };
</script>
